/**
 * Animated texture presets for water and lava cuboids.
 * Shared between MaterialEditor (apply to existing) and VoxelEditor (place new).
 * Each preset is a single texture applied to all 6 faces via triplanar group,
 * with preset opacity and noCollision enabled.
 */

export const ANIMATED_PRESETS = [
  {
    id: 'water_1', label: 'Water',
    texture: 'textures/gifs/water/water_1.gif',
    thumbnail: 'textures/gifs/water/water_1.gif',
    opacity: 0.55, noCollision: true
  },
  {
    id: 'water_1_flowdown', label: 'Water Flow Down',
    texture: 'textures/gifs/water/water_1_flowdown.gif',
    thumbnail: 'textures/gifs/water/water_1_flowdown.gif',
    opacity: 0.55, noCollision: true
  },
  {
    id: 'water_1_flowleft', label: 'Water Flow Left',
    texture: 'textures/gifs/water/water_1_flowleft.gif',
    thumbnail: 'textures/gifs/water/water_1_flowleft.gif',
    opacity: 0.55, noCollision: true
  },
  {
    id: 'lava_1', label: 'Lava',
    texture: 'textures/gifs/lava/lava_1.gif',
    thumbnail: 'textures/gifs/lava/lava_1.gif',
    opacity: 0.55, noCollision: true
  },
  {
    id: 'lava_1_flowdown', label: 'Lava Flow Down',
    texture: 'textures/gifs/lava/lava_1_flowdown.gif',
    thumbnail: 'textures/gifs/lava/lava_1_flowdown.gif',
    opacity: 0.55, noCollision: true
  },
  {
    id: 'lava_1_flowleft', label: 'Lava Flow Left',
    texture: 'textures/gifs/lava/lava_1_flowleft.gif',
    thumbnail: 'textures/gifs/lava/lava_1_flowleft.gif',
    opacity: 0.55, noCollision: true
  }
];
